var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ visible: _vm.messages.length > 0},attrs:{"id":"messageBar"}},_vm._l((_vm.messages),function(message){return _c('div',{staticClass:"message"},[_vm._v("\n\t\t"+_vm._s(message.text)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }